/**
 * Inject React Router `location` as a prop for class components
 * that still expect Gatsby's page `location` prop.
 */

import React from 'react'
import { useLocation } from 'react-router-dom'

export default function withLocation(Component) {
  function WithLocation(props) {
    const location = useLocation()
    return <Component {...props} location={location} />
  }

  const name = Component.displayName || Component.name || `Component`
  WithLocation.displayName = `withLocation(${name})`
  return WithLocation
}
